<template>
    <div class="lang-button" ref="menu" v-outside-click="closeMenu">
        <div class="custom-select" @blur="open = false">
            <div @click="open = !open" class="rrr text-bark-grey">
                <div class="l-img"/>
                <div>{{getLang}}</div>
            </div>
            <div class="items text-bark-grey" :class="open ? 'open' : 'selectHide' ">
                <div v-for="(item, index) in languages" :key="index" @click="changeLang(item)" style="width: max-content">{{ item.title }}</div>
            </div>
        </div>
    </div>
</template>

<script>

import {useCounterStore} from "@/store";
import OutsideClickDirective from "@/utils/OutsideClickDirective";

export default {
    name: 'LangButton',
    directives: {
        OutsideClick: OutsideClickDirective,
    },
    props: {
        viewTitle: {
            type: Boolean,
            default: true
        }
    },
    mounted () {
        const selectedLang = localStorage.getItem('lang');
        this.currentLang = selectedLang || 'kg';
        this.$root.$i18n.locale = this.currentLang;
    },
    data () {
        const fontStore = useCounterStore();
        return {
            fontStore,
            currentLang: '',
            open: false,
            languages: [
                { title: 'RUS', code: 'ru' },
                { title: 'KGZ', code: 'kg' }
            ]
        }
    },

    computed: {
        getLang () {
            return this.languages.find(el => el.code === this.currentLang)?.title;
        }
    },
    methods: {
        closeMenu() {
            this.open = false;
        },
        changeLang (lang) {
            localStorage.setItem('lang', lang.code);
            this.$router.go(0);
        }
    }
}

</script>
